import MainPage from 'navigation/pages/MainPage';
import modulesMap from 'core/modulesMap';
import EditorialSubnav from 'components/editorial/EditorialSubnav';
import DragController from 'components/drag-controller/DragController';
import EditorialRelatedContent from 'components/editorial-related-content/EditorialRelatedContent';
import ArticleGallery from './partials/ArticleGallery';
import ArticleImage from './partials/ArticleImage';
import BlockProducts from '../catalog/partials/BlockProducts';
class Article extends MainPage {
    getModulesMap() {
        return {
            ...modulesMap,
            image: ['.article-image', ArticleImage],
            dragController: ['.article-carousel__wrapper', DragController],
            gallery: ['.article-gallery', ArticleGallery],
            subnav: ['.editorial-subnav', EditorialSubnav],
            products: ['.block-products', BlockProducts],
            editorialRelatedContent: ['.editorial-related-content', EditorialRelatedContent]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            snaps: true,
            start: 1
        };
    }
    initialized() {
        super.initialized();
    }
    resize() {
        super.resize();
        if (this.modules.subnav)
            this.modules.subnav.endOfPage = this.refs.articleWrapper.getBoundingClientRect().bottom;
    }
}
export default Article;
